<template>
    <div class="version-details">
        <div v-for="(item, index) in versinData" :key="index" class="version-box">
            <p class="date-line" @click="contentShow(item)">
                {{item.time}}
            </p>
            <div class="bgc-white">
                <!--<div class="gray-line" v-show="item.index !== versinData.length - 1"></div>-->
              <div class="gray-line" v-show="item.index !== 0 && versinData.length > 1"></div>
              <div class="version-content">
                    <div class="content-header" @click="contentShow(item)">{{item.title}}</div>
                    <div :class="[item.body, 'content-body']" v-show="index === 0 ?  true: false">
                        <div class="content-box">
                            <p v-for="(text, index) in item.content" :key="index">{{text}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      contentShowFlag: true,
      versinData: [{
          time: "2020年11月30日",
          title: "V0.1",
          body: "content-body0",
          index: 0,
          content: []
        }
      ]
    };
  },
  methods: {
    contentShow(item) {
      $("." + item.body).slideToggle(500);
    }
  }
};
</script>
<style lang="less" scoped>
p {
  margin: 0;
  line-height: 20px;
}
.version-details {
  position: relative;
  height: 100%;
  padding-top: 30px;
  padding-left: 150px;
  overflow-y: scroll;
  .version-box {
    display: flex;
    text-align: center;
    .date-line {
      width: 120px;
      height: 30px;
      font-size: 14px;
      border-radius: 5px;
      position: relative;
      z-index: 99;
      line-height: 30px;
      cursor: pointer;
    }
    .bgc-white {
      flex: 1;
      margin-left: 30px;
      padding-bottom: 15px;
      position: relative;
      .gray-line {
        content: "";
        height: 100%;
        width: 4px;
        background: gray;
        position: absolute;
        left: -90px;
        top: 0;
      }
      .version-content {
        width: 100%;
        .content-header {
          width: 100%;
          height: 30px;
          line-height: 30px;
          text-align: left;
          padding-left: 15px;
          font-weight: 700;
          cursor: pointer;
        }
        .content-body {
          width: 100%;
          height: 270px;
          text-align: left;
          padding-left: 15px;
          overflow: scroll;
          padding: 10px;
          .content-box {
            padding: 10px;
            border-radius: 5px;
          }
        }
      }
    }
  }
}
</style>


